import React,{useState,useEffect,useRef} from 'react';
import {Styles} from './Styles';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTint, faWineBottle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LinearProgress from '@material-ui/core/LinearProgress';


interface Props {
    stWater: number,
    stMagenta: number,
    stCyan: number,
    stYellow: number,
    enWater: number,
    enMagenta: number,
    enCyan: number,
    enYellow: number,
    finish():void,
}

let tid:NodeJS.Timeout;

const FourMeters = (props:Props)=> {
    const classes = Styles.base();
    const [step,setStep] = useState(0);

    library.add(faTint,faWineBottle);
    const progress = useRef(() => {});

    useEffect(() => {
        progress.current = () => {
            if (step < 10) {
                setStep(step+1);
            } else {
                clearInterval(tid);
                props.finish();
            }
        };
    });
  
    useEffect(() => {
        function tick() {
            progress.current();
        }
        tid = setInterval(tick, 50);

        return () => {
            clearInterval(tid);
            props.finish();
        };
    }, []);

    const v1 = Math.round((props.enWater-props.stWater)/10*step) + props.stWater;
    const v2 = Math.round((props.enMagenta-props.stMagenta)/10*step) + props.stMagenta;
    const v3 = Math.round((props.enCyan-props.stCyan)/10*step) + props.stCyan;
    const v4 = Math.round((props.enYellow-props.stYellow)/10*step) + props.stYellow;

    return (
        <div id="four-meters">
            <div style={{margin:"0",position:"relative"}}>
                <span style={{color:"navy"}}><FontAwesomeIcon icon="tint"/></span>
                <span style={{position:"absolute",top:"0",right:"0"}}>{v1}</span>
                <LinearProgress variant="buffer" value={v1} valueBuffer={props.enWater} classes={{barColorPrimary:classes.barColorWater}}/>
            </div>
            <div style={{margin:"0",position:"relative"}}>
                <span style={{color:"cyan"}}><FontAwesomeIcon icon="wine-bottle"/>C</span>
                <span style={{position:"absolute",top:"0",right:"0"}}>{v3}</span>
                <LinearProgress variant="buffer" value={v3} valueBuffer={props.enCyan} classes={{barColorPrimary:classes.barColorCyan}}/>
            </div>
            <div style={{margin:"0",position:"relative"}}>
                <span style={{color:"magenta"}}><FontAwesomeIcon icon="wine-bottle"/>M</span>
                <span style={{position:"absolute",top:"0",right:"0"}}>{v2}</span>
                <LinearProgress variant="buffer" value={v2} valueBuffer={props.enMagenta} classes={{barColorPrimary:classes.barColorMagenta}}/>
            </div>
            <div style={{margin:"0",position:"relative"}}>
                <span style={{color:"yellow"}}><FontAwesomeIcon icon="wine-bottle"/>Y</span>
                <span style={{position:"absolute",top:"0",right:"0"}}>{v4}</span>
                <LinearProgress variant="buffer" value={v4} valueBuffer={props.enYellow} classes={{barColorPrimary:classes.barColorYellow}}/>
            </div>
        </div>
    );
}

export default FourMeters;
